
  import { Component, Vue , Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
  @Component({  
    name: '',
    components: {
      PageFooter
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:{}}) msg!:any
    private choosemsg:any = {
      IsJumpExternalWxApp:false,
      ExternalWxAppId:'',
      ExternalWxAppOriginalId:'',
      JumpPageName:'',
      pageurl:'',
      Id:-1,
      JumpPath:'',
    }

    private mounted () {
      this.choosemsg = {
        IsJumpExternalWxApp:this.msg.IsJumpExternalWxApp||false,
        ExternalWxAppId:this.msg.ExternalWxAppId||'',
        ExternalWxAppOriginalId:this.msg.ExternalWxAppOriginalId,
        JumpPageName:this.msg.JumpPageName||'',
        pageurl:this.msg.JumpPath||'',
        Id:this.msg.Id||-1,
        JumpPath:this.msg.JumpPath||'',
      }
      // console.log(this.msg,'222')
    }
    
    private returnchoosemsg(){
      return this.choosemsg
    }
  }
